<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { EditorState, generateName } from "@common/Common";
    import { CurrencyDenomination, TimeFrameGranularity } from "@common/types";
    import { guid } from "@common/Guid";
    import { ProjectPlanTemplateEditorViewModel } from "@Quest/ProjectPlanTemplates/Components/ProjectPlanTemplateEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectPlanTemplateEditor extends Vue
    {
        get vm(): ProjectPlanTemplateEditorViewModel { return this.$props.viewModel as ProjectPlanTemplateEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get confirmButtonLabel(): string { return this.vm.state === EditorState.Creator ? 'Create' : 'Update'; }
        get modalTitle(): string { return this.vm.state === EditorState.Creator ? 'New business case template' : 'Edit the business case template'; }

        onFormSubmit()
        {
            if (this.vm.state === EditorState.Creator)
            {
                this.$emit('create-template', this.vm.data);
            }
            else if (this.vm.state === EditorState.Editor)
            {
                this.$emit('update-template', this.vm.data);
            }
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="project-plan-template-editor-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" v-model.trim="vm.data.Name" class="form-control" required minlength="2" maxlength="100" />
                            </div>

                            <div class="form-group">
                                <label>Description</label>
                                <textarea v-model.trim="vm.data.Description" class="form-control" maxlength="250" />
                            </div>

                            <hr />

                            <div class="form-group">
                                <label for="account">Granularity</label>
                                <select id="account" v-model="vm.data.Granularity" class="form-control">
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Yearly">Yearly</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="denomination">Currency denomination</label>
                                <select id="denomination" v-model="vm.data.Denomination" class="form-control">
                                    <option value="Unit">Unit</option>
                                    <option value="Thousand">Thousand</option>
                                    <option value="Million">Million</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Project execution (in months)</label>
                                <input type="number" v-model.number="vm.data.DurationInMonths" class="form-control" required min="1" step="1" />
                            </div>

                            <div class="form-group">
                                <label>Planning horizon (in years)</label>
                                <input type="number" v-model.number="vm.data.PlanningHorizonInYears" class="form-control" required min="1">
                            </div>
                        </form>


                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="project-plan-template-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>